//amgular
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

//local
import {
  ApiConstants,
  HttpResult,
  PollyHttpHelper,
} from "@app/shared";

import { SecurityConfig } from '@app/core';
import { GetCarouselRequest, GetCatalogResponse } from '../dtos';

@Injectable({
    providedIn: 'root'
  })
export class CatalogHttpService 
{
    constructor(
      private http: HttpClient, 
      private applicationConfig: SecurityConfig) {    
    }

    public getCarousels(request: GetCarouselRequest): HttpResult<GetCatalogResponse> 
    {

      let serviceUri = `${this.applicationConfig.applicationUri}/v2/catalog/carousels`;

      console.log(`POST: ${serviceUri}`, request); 
      
      return PollyHttpHelper.Invoke('POST', () => this.http.post<GetCatalogResponse>(serviceUri, request, { headers: ApiConstants.DefaultHeaders }));
    }    

    public getMenus(request: GetCarouselRequest): HttpResult<GetCatalogResponse> 
    {

      let serviceUri = `${this.applicationConfig.applicationUri}/v2/catalog/carousels`;

      console.log(`POST: ${serviceUri}`, request); 
      
      return PollyHttpHelper.Invoke('POST', () => this.http.post<GetCatalogResponse>(serviceUri, request, { headers: ApiConstants.DefaultHeaders }));
    }    
}